import Cookies from 'js-cookie';

const COOKIE_KEY = 'paldock';
const COOKIE_EXPIRES_DAYS = 30;

export type PaldockData = {
	leadId?: string;
	loanAmount?: number;
};

export const storePaldockData = (data: PaldockData): void => {
	Cookies.set(COOKIE_KEY, JSON.stringify(data), { expires: COOKIE_EXPIRES_DAYS });
};

export const getPaldockData = (): PaldockData | null => {
	const value = Cookies.get(COOKIE_KEY);
	if (!value) return null;
	try {
		return JSON.parse(value) as PaldockData;
	} catch {
		return null;
	}
};

export const clearPaldockData = (): void => {
	Cookies.remove(COOKIE_KEY);
};
